export default state => type => {
    let items = state[type];
    return items ? items : [];
}